import { render, staticRenderFns } from "./SendGroupEmail.vue?vue&type=template&id=fbedda28"
import script from "./SendGroupEmail.vue?vue&type=script&lang=js"
export * from "./SendGroupEmail.vue?vue&type=script&lang=js"
import style0 from "./SendGroupEmail.vue?vue&type=style&index=0&id=fbedda28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports